import styled from 'styled-components';

import { VIDEO_AREA_Z_INDEX } from 'components/b2c/Mp3KbpPlayer/Mp3KbpPlayer.style';
import { colorUsage, getSpacing } from 'stylesheetB2c';

export const PlayButton = styled.button`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${getSpacing(47)};
  background-color: ${colorUsage.playButtonBackgroundColor};
  color: ${colorUsage.playButtonIconColor};
  height: ${getSpacing(50)};
  width: ${getSpacing(50)};
  border-radius: 50%;
  border: none;
  position: absolute;
  z-index: ${VIDEO_AREA_Z_INDEX + 1};

  :focus {
    outline: thin dotted;
  }
`;
PlayButton.displayName = 'PlayButton';

export const PlayerPlaceholderContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;
PlayerPlaceholderContainer.displayName = 'PlayerPlaceholderContainer';

export const BamOnlineLogoBackground = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: ${colorUsage.webPlayer.playerAreaBackground};
`;
BamOnlineLogoBackground.displayName = 'BamOnlineLogoBackground';

export const BamOnlineLogo = styled.img`
  width: 40%;

  &:not(:last-child) {
    margin-bottom: ${getSpacing(10)};
  }
`;
